import type { ComponentChildren } from "preact";
import { ProviderComponentRuleList } from "@airvantage/ui";
import { componentRuleList } from "../constants/componentRuleList";
import VIEW_COMPONENT_LIST from "../components.js";

type ProviderViewListProps = {
  children: ComponentChildren;
  /**
   * Optional context object for rule matching.
   * Can include user information, rights, or other contextual data.
   */
  context?: object;
};

/**
 * Provider wrapper for ViewList components.
 *
 * This component sets up the component resolution context for ViewList,
 * allowing views to use query-based component resolution via DynamicComponent.
 *
 * @example
 * ```tsx
 * <ProviderViewList context={{ userRights }}>
 *   <ViewList value={viewList} onChange={setViewList} />
 * </ProviderViewList>
 * ```
 */
export function ProviderViewList({
  children,
  context = {},
}: ProviderViewListProps) {
  return (
    <ProviderComponentRuleList
      context={context}
      value={componentRuleList}
      importModule={async (componentModulePath: string) =>
        VIEW_COMPONENT_LIST.find(
          ({ path }) => path === componentModulePath,
        )?.module()
      }
    >
      {children}
    </ProviderComponentRuleList>
  );
}
